<sb-dialog-header>
  <h3 sb-dialog-title>
    {{ '[covered] of [total] shifts covered today' | translate: { covered: coveredCount(), total: rows().length } }}
  </h3>
</sb-dialog-header>

<sb-dialog-content>
  <ul class="reset-ul flex flex-col gap-sm">
    @for (row of rows(); track row.shift.occurrence_id) {
      <li>
        <find-cover-shift-row [shift]="row.shift">
          @if (row.coveredBy; as employee) {
            <div class="flex items-center gap-sm">
              <!-- Decorative: the initials would otherwise lead into the employee's name. -->
              <sb-avatar
                aria-hidden="true"
                data-hj-suppress
                size="sm"
                [firstName]="employee.first_name"
                [lastName]="employee.last_name"
                [url]="employee.avatar_30x30"
                [colorSeed]="employee.id"
              />

              <span class="text-base text-default" data-hj-suppress>{{ employee.name }}</span>

              <sb-badge class="shrink-0" color="green">{{ 'Covered' | translate }}</sb-badge>
            </div>
          } @else {
            <div class="flex items-center gap-sm">
              <button
                sb-button
                color="primaryTransparent"
                size="sm"
                type="button"
                [attr.aria-label]="'Find cover for [shift]' | translate: { shift: row.shift.Shift?.long_name }"
                (click)="findCover(row.shift.occurrence_id)"
              >
                {{ 'Find cover' | translate }}
              </button>

              <sb-badge class="shrink-0" color="yellow">{{ 'Still open' | translate }}</sb-badge>
            </div>
          }
        </find-cover-shift-row>
      </li>
    }
  </ul>
</sb-dialog-content>

<sb-dialog-footer>
  <sb-dialog-footer-actions [align]="'end'">
    <button sb-button color="primary" type="button" (click)="done()">
      {{ 'Done' | translate }}
    </button>
  </sb-dialog-footer-actions>
</sb-dialog-footer>
